import { ArticleLinkComponent } from './components/Article/article-elements/article-link/article-link.component';
import { ArticleImageLayoutModelComponent } from './components/Article/article-elements/article-image-layout-model/article-image-layout-model.component';
import { ArticleVideoComponent } from './components/Article/article-elements/article-video/article-video.component';
import { ArticleService } from './services/article.service';
import { NgModule, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgOtpInputModule } from 'ng-otp-input';
import { UiHeaderComponent } from './Design/components/ui-header/ui-header.component';
import { UiLandingComponent } from './Design/pages/ui-landing/ui-landing.component';
import { UiProfileComponent } from './Design/pages/ui-profile/ui-profile.component';
import { UiEditDetailsComponent } from './Design/pages/ui-edit-details/ui-edit-details.component';
import { UiOnboardingComponent } from './Design/pages/ui-onboarding/ui-onboarding.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SignupModalComponent } from './components/signup-modal/signup-modal.component';
import { LoginModalComponent } from './components/login-modal/login-modal.component';
import { ForgotpasswordModalComponent } from './components/forgotpassword-modal/forgotpassword-modal.component';
import { EmailconfirmationModalComponent } from './components/emailconfirmation-modal/emailconfirmation-modal.component';
import { OtpnotreceivedModalComponent } from './components/otpnotreceived-modal/otpnotreceived-modal.component';
import { ResetPasswordModalComponent } from './components/reset-password-modal/reset-password-modal.component';
import { AskingDetailsModalComponent } from './components/asking-details-modal/asking-details-modal.component';
import { ProfileModalComponent } from './components/profile-modal/profile-modal.component';
import { SearchLocationModalComponent } from './components/search-location-modal/search-location-modal.component';
import { ConfirmLocationModalComponent } from './components/confirm-location-modal/confirm-location-modal.component';
import { RegistrationDoneModalComponent } from './components/registration-done-modal/registration-done-modal.component';
import { SkipLoginModalComponent } from './components/skip-login-modal/skip-login-modal.component';
import { SkippedLoginModalComponent } from './components/skipped-login-modal/skipped-login-modal.component';
import { NgbScrollSpyModule } from '@ng-bootstrap/ng-bootstrap';
import { UiListingComponent } from './Design/pages/ui-listing/ui-listing.component';
import { UiBusinessDetailComponent } from './Design/pages/ui-business-detail/ui-business-detail.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { JsonPipe } from '@angular/common';
import { NgxStarsModule } from 'ngx-stars';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiGalleryComponent } from './Design/pages/ui-gallery/ui-gallery.component';
import { ButtonComponent } from './shared/components/button/button.component';
import { InputComponent } from './shared/components/input/input.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { EditPersonalDetailsComponent } from './components/edit-personal-details/edit-personal-details.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { MiniMenuSettingsComponent } from './components/mini-menu-settings/mini-menu-settings.component';
import { MiniMenuPromoModalComponent } from './components/mini-menu-promo-modal/mini-menu-promo-modal.component';
import { MiniMenuCropEditorComponent } from './components/mini-menu-crop-editor/mini-menu-crop-editor.component';
import { MiniMenuLandingCropModalComponent } from './components/mini-menu-landing-crop-modal/mini-menu-landing-crop-modal.component';
import { MiniMenuAppearanceModalComponent } from './components/mini-menu-appearance-modal/mini-menu-appearance-modal.component';
import { MiniMenuQrPosterModalComponent } from './components/mini-menu-qr-poster-modal/mini-menu-qr-poster-modal.component';
import { MiniMenuSiteComponent } from './components/mini-menu-site/mini-menu-site.component';
import { MiniMenuExpandableDirective } from './components/mini-menu-site/mini-menu-expandable.directive';
import { SelectComponent } from './shared/components/select/select.component';
import { ToastrModule } from 'ngx-toastr';
import { PhotosSectionComponent } from './shared/components/photos-section/photos-section.component';
import { MenuSectionComponent } from './shared/components/menu-section/menu-section.component';
import { UiLoaderComponent } from './Design/components/ui-loader/ui-loader.component';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { AuthGuard } from './shared/auth/auth.guard';
import { AuthService } from './shared/auth/auth.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderService } from './services/loader.service';
import { ListingComponent } from './components/listing/listing.component';
import { RestaurantDetailSectionComponent } from './shared/components/restaurant-detail-section/restaurant-detail-section.component';
import { RestaurantDetailModalComponent } from './components/restaurant-detail-modal/restaurant-detail-modal.component';
import { ListingSearchComponent } from './components/listing-search/listing-search.component';
import { PersonalDetailsComponent } from './components/personal-details/personal-details.component';
import { UserService } from './services/user.service';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { SliderThumbnailComponent } from './shared/components/slider-thumbnail/slider-thumbnail.component';
import { AdvertisementComponent } from './shared/components/advertisement/advertisement.component';
import { ReviewComponent } from './shared/components/review/review.component';
import { DeleteConfirmationPopupComponent } from './shared/components/delete-confirmation-popup/delete-confirmation-popup.component';
import { MenuComponent } from './shared/components/menu/menu.component';
import { TextareaComponent } from './shared/components/textarea/textarea.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { GalleryImgComponent } from './shared/components/gallery-img/gallery-img.component';
import { DatepickerInputComponent } from './shared/components/datepicker-input/datepicker-input.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleLocationSearchComponent } from './shared/components/google-location-search/google-location-search.component';
import { ConfirmGoogleLocationComponent } from './shared/components/confirm-google-location/confirm-google-location.component';
import { UiPostComponent } from './Design/pages/ui-post/ui-post.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DndModule } from 'ngx-drag-drop';
import { UiAllArticlesComponent } from './Design/pages/ui-all-articles/ui-all-articles.component';
import { NgxEditorModule } from 'ngx-editor';
import { ArticleEditComponent } from './components/Article/article-edit/article-edit.component';
import { DropdownComponent } from './shared/components/dropdown/dropdown.component';
import { ArticleHeaderComponent } from './components/Article/article-elements/article-header/article-header.component';
import { ArticleParagraphComponent } from './components/Article/article-elements/article-paragraph/article-paragraph.component';
import { AllArticlesComponent } from './components/Article/all-articles/all-articles.component';
import { ArticlesCardComponent } from './shared/components/articles-card/articles-card.component';
import { ArticleUploadImageComponent } from './components/Article/article-elements/article-upload-image/article-upload-image.component';
import { RadioButtonComponent } from './shared/components/radio-button/radio-button.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ArticleListComponent } from './components/Article/article-elements/article-list/article-list.component';
import { ArticleSublineComponent } from './components/Article/article-elements/article-subline/article-subline.component';
import { SetLocationModalComponent } from './components/set-location-modal/set-location-modal.component';
import { ArticleQuoteComponent } from './components/Article/article-elements/article-quote/article-quote.component';
import { ArticleLeadComponent } from './components/Article/article-elements/article-lead/article-lead.component';
import { ArticleImageComponent } from './components/Article/article-elements/article-image/article-image.component';
import { InputPasswordComponent } from './shared/components/input-password/input-password.component';
import { AlphabetOnlyDirective } from './shared/Directives/alphabet-only.directive';
import { NumbersOnlyDirective } from './shared/Directives/numbers-only.directive';
import { ArticleHighlightModelComponent } from './components/Article/article-elements/article-highlight-model/article-highlight-model.component';
import { ArticlePreviewComponent } from './components/Article/article-preview/article-preview.component';
import { NoSpecialCharacterDirective } from './shared/Directives/no-special-character.directive';
import { BusinessDetailHeaderComponent } from './shared/components/business-detail-header/business-detail-header.component';
import { FoodNewsComponent } from './shared/components/food-news/food-news.component';
import { DealsOfferComponent } from './shared/components/deals-offer/deals-offer.component';
import { DashboardSliderComponent } from './shared/components/dashboard-slider/dashboard-slider.component';
import { CompleteInfoModalComponent } from './components/complete-info-modal/complete-info-modal.component';
import { ConfirmInfoModalComponent } from './components/confirm-info-modal/confirm-info-modal.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BusinessHourModalComponent } from './components/business-hour-modal/business-hour-modal.component';
import { RenderWebViewComponent } from './components/render-web-view/render-web-view.component';
import { DayBusinessHourItemComponent } from './components/day-business-hour-item/day-business-hour-item.component';
import { DashboardArticleCardComponent } from './shared/components/dashboard-article-card/dashboard-article-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { WhyHungeryComponent } from './components/why-hungery/why-hungery.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { GetInTouchComponent } from './components/get-in-touch/get-in-touch.component';
import { PersonalizePlanComponent } from './components/personalize-plan/personalize-plan.component';
import { FooterComponent } from './components/footer/footer.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ShortPricePipe } from './shared/pipes/short-price.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LocationSearchComponent } from './shared/components/location-search/location-search.component';
import { MobileLocationDockComponent } from './shared/components/mobile-location-dock/mobile-location-dock.component';
import { ProductUploadComponent } from './shared/components/product-upload/product-upload.component';
import { ImageConfigurationComponent } from './shared/components/image-configuration/image-configuration.component';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ArticleAddRestoDetailsComponent } from './components/Article/article-elements/article-add-resto-details/article-add-resto-details.component';
import { PlaystoreInfoModalComponent } from './components/playstore-info-modal/playstore-info-modal.component';
import { TranslationPopupComponent } from './components/Article/translation-popup/translation-popup.component';
import { RestoPublishInfoPopupComponent } from './components/resto-publish-info-popup/resto-publish-info-popup.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy/privacy-policy.component';
import { PrivacyPolicyModalComponent } from './components/privacy-policy/privacy-policy-modal/privacy-policy-modal.component';
import { BusinessUploadComponent } from './shared/components/business-upload/business-upload.component';
import { PreRegistrationReviewComponent } from './components/pre-registration-review/pre-registration-review.component';
import { PreRegisterBusinessImageConfigurationComponent } from './shared/components/pre-register-business-image-configuration/pre-register-business-image-configuration.component';
import { WhyHungeryExternalComponent } from './why-hungery-external/why-hungery-external.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    UiHeaderComponent,
    UiLandingComponent,
    HeaderComponent,
    DashboardComponent,
    SignupModalComponent,
    LoginModalComponent,
    InputComponent,
    ButtonComponent,
    ForgotpasswordModalComponent,
    EmailconfirmationModalComponent,
    OtpnotreceivedModalComponent,
    UiProfileComponent,
    UiEditDetailsComponent,
    UiOnboardingComponent,
    UiListingComponent,
    UiBusinessDetailComponent,
    UiGalleryComponent,
    ResetPasswordModalComponent,
    AskingDetailsModalComponent,
    ProfileModalComponent,
    SearchLocationModalComponent,
    ConfirmLocationModalComponent,
    RegistrationDoneModalComponent,
    SkipLoginModalComponent,
    SkippedLoginModalComponent,
    EditPersonalDetailsComponent,
    OnboardingComponent,
    MiniMenuSettingsComponent,
    MiniMenuPromoModalComponent,
    MiniMenuCropEditorComponent,
    MiniMenuLandingCropModalComponent,
    MiniMenuAppearanceModalComponent,
    MiniMenuQrPosterModalComponent,
    MiniMenuSiteComponent,
    MiniMenuExpandableDirective,
    SelectComponent,
    PhotosSectionComponent,
    MenuSectionComponent,
    UiLoaderComponent,
    LoaderComponent,
    PersonalDetailsComponent,
    BusinessDetailComponent,
    SliderThumbnailComponent,
    AdvertisementComponent,
    ReviewComponent,
    DeleteConfirmationPopupComponent,
    MenuComponent,
    TextareaComponent,
    ListingComponent,
    RestaurantDetailSectionComponent,
    RestaurantDetailModalComponent,
    ListingSearchComponent,
    PersonalDetailsComponent,
    GalleryComponent,
    GalleryImgComponent,
    DatepickerInputComponent,
    GoogleLocationSearchComponent,
    ConfirmGoogleLocationComponent,
    UiPostComponent,
    UiAllArticlesComponent,
    ArticleEditComponent,
    DropdownComponent,
    ArticleHeaderComponent,
    ArticleParagraphComponent,
    AllArticlesComponent,
    ArticlesCardComponent,
    ArticleUploadImageComponent,
    RadioButtonComponent,
    ArticleListComponent,
    ArticleSublineComponent,
    SetLocationModalComponent,
    ArticleQuoteComponent,
    ArticleLeadComponent,
    ArticleVideoComponent,
    ArticleImageComponent,
    InputPasswordComponent,
    AlphabetOnlyDirective,
    NumbersOnlyDirective,
    NoSpecialCharacterDirective,
    ArticleImageLayoutModelComponent,
    ArticleHighlightModelComponent,
    ArticleLinkComponent,
    ArticlePreviewComponent,
    BusinessDetailHeaderComponent,
    FoodNewsComponent,
    DealsOfferComponent,
    DashboardSliderComponent,
    CompleteInfoModalComponent,
    ConfirmInfoModalComponent,
    BusinessHourModalComponent,
    RenderWebViewComponent,
    DayBusinessHourItemComponent,
    DashboardArticleCardComponent,
    WhyHungeryComponent,
    PricingComponent,
    GetInTouchComponent,
    PersonalizePlanComponent,
    FooterComponent,
    ShortPricePipe,
    LocationSearchComponent,
    MobileLocationDockComponent,
    ProductUploadComponent,
    ImageConfigurationComponent,
    ArticleAddRestoDetailsComponent,
    PlaystoreInfoModalComponent,
    TranslationPopupComponent,
    RestoPublishInfoPopupComponent,
    PrivacyPolicyComponent,
    PrivacyPolicyModalComponent,
    BusinessUploadComponent,
    PreRegistrationReviewComponent,
    PreRegisterBusinessImageConfigurationComponent,
    WhyHungeryExternalComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxMasonryModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgbScrollSpyModule,
    NgbDatepickerModule,
    JsonPipe,
    NgxStarsModule,
    NgSelectModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 5000,
    }), // ToastrModule added
    GoogleMapsModule,
    NgMultiSelectDropDownModule.forRoot(),
    DndModule,
    NgxEditorModule,
    ImageCropperModule,
    NgxMaterialTimepickerModule,
    InfiniteScrollModule,
    AngularCropperjsModule,
    NgxSkeletonLoaderModule.forRoot({
      animation: 'progress-dark',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AuthService,
    AuthGuard,
    LoaderService,
    UserService,
    ArticleService,
    DeviceDetectorService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
